<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: Sephiroth·D·Kid
 * @LastEditTime: 2019-07-04 09:34:24
 * @Description: 鲸鱼优选首页
 -->

<template>
  <div class="prefect-select-wrapper">
    <banner></banner>
    <router-view class="main-wrapper"></router-view>
  </div>
</template>
<script>
import Banner from './components/banner';
export default {
  name: 'prefect-select',
  components: {
    Banner
  }
};
</script>
<style lang="less" scope>
.perfect-select-wrapper {
  .main-wrapper {
    width: 1200px;
    margin: 0 auto;
  }
}
</style>
